import { ICommand } from 'core-ts-types';
import { lowerCase, startCase } from 'lodash4';
import { StudentValueModel } from '../../../../../global/components/student_value/model/student_value_model';
import { APAdvisorText } from './../../../../../global/servants/ap_advisor_text_servant';
class PreviewPlanAutoGeneratedFailureController {
  private contactAdvisorButtonHidden: boolean = false;
  private contactAdvisorLabel: string;
  private contactAdvisorButtonLabel: string;
  constructor(
    private $timeout: ng.ITimeoutService,
    private appConfigModel: any,
    private FEATURE_APPOINTMENTS: any,
    private $state: ng.ui.IStateService,
    private ngStudentValueModel: StudentValueModel,
    private ngPreviewTermPlanConstant: any,
    private phxFeatureConfiguration: any,
    private ngAPAdvisorText: APAdvisorText,
    private completedAutoGeneratedPreviewPlanShowingCommand: ICommand
  ) {
    this.contactAdvisorButtonHidden = !this.appConfigModel.isFeatureEnabled(FEATURE_APPOINTMENTS);
    this.contactAdvisorLabel = lowerCase(this.ngAPAdvisorText.advisorLabel);
    this.contactAdvisorButtonLabel = 'Contact ' + startCase(this.contactAdvisorLabel);
  }

  reportProblemClicked() {
    const contactFormTrigger = angular.element('app-support button');
    this.$timeout(() => contactFormTrigger.triggerHandler('click'), 0);
  }

  updateApPreviewShownModel() {
    const currentStudentValue = {};
    this.ngStudentValueModel
      .keys()
      .forEach((key: string) => (currentStudentValue[key] = this.ngStudentValueModel.getValueByKey(key)));
    currentStudentValue[this.ngPreviewTermPlanConstant['AP_PREVIEW_AUTO_GENERATED_TERM_PLAN_SHOWN']] = 'True';
    this.ngStudentValueModel.update(currentStudentValue);
  }

  async goBackButtonClicked() {
    await this.completedAutoGeneratedPreviewPlanShowingCommand();
    this.updateApPreviewShownModel();
    this.$state.go('my.planner.default');
  }
}

angular.module('capability-ng-academic-planner').component('previewPlanAutoGeneratedFailure', {
  templateUrl:
    'capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_plan_auto_generated_failure/preview_plan_auto_generated_failure.html',
  controller: PreviewPlanAutoGeneratedFailureController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/preview_plan/components/preview_plan_auto_generated_failure/preview_plan_auto_generated_failure.ts